import React from 'react';
import { Box } from '@chakra-ui/react';
import CheckTable from './components/CheckTable';

const CustomerSavingPlans = () => {
  return (
    <Box mt={-5}>
      <CheckTable />
    </Box>
  );
};

export default CustomerSavingPlans;
